import * as yaml from 'js-yaml';
import { ValidationError } from './errors';

export const safeRulesYamlLoad = (rules: string) => {
  try {
    const safeRules = yaml.load(
      rules.replaceAll(/{{(.*?)}}|{(.*?)}|{%.*%}((.|\n)*){% endfor %}/g, '')
    );
    return safeRules;
  } catch (error) {
    throw new ValidationError('Failed to load yml file. Invalid cm.');
  }
};
